// extracted by mini-css-extract-plugin
module.exports = {"Loader":"Spinner_Loader__3i0-a","load8":"Spinner_load8__lIH4M"};